import React from "react";
import PropTypes from "prop-types";

const ClassroomSvg = props => {
  return (
    <svg width={props.width} height={props.height} viewBox="0 0 100 100">
      <g
        id="Class-Discussion"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M80.1387368,89.2990142 C82.6579043,89.2990142 84.0817817,87.5465498 84.0817817,84.7718145 L84.0817817,76.630157 L85.5786783,76.630157 C94.3044907,76.630157 100,71.4092735 100,62.354874 L100,41.7269076 C100,32.6359985 94.267981,27.3420957 85.4691493,27.3420957 L79.8466594,27.3420957 L79.8466594,24.8594378 C79.8466594,15.4399416 74.2971888,10 64.8046732,10 L15.0419861,10 C5.91456736,10 0,15.4399416 0,24.8594378 L0,56.8419131 C0,66.2248996 5.87805769,71.6283315 14.9689668,71.6283315 L19.4596568,71.6283315 L19.4596568,80.8652793 C19.4596568,83.6765243 20.8835341,85.3559693 23.4757211,85.3559693 C25.3742242,85.3559693 26.7250821,84.6987952 29.0251917,82.6907631 L40.4162103,72.5045637 C42.8988682,75.16977 46.6958744,76.630157 51.5151515,76.630157 L63.4173056,76.630157 L74.9543629,86.4877693 C77.1449434,88.3862724 78.3497627,89.2990142 80.1387368,89.2990142 Z M25.0091274,78.7477181 L25.0091274,68.9631252 C25.0091274,66.9185834 23.7677985,66.0058415 22.1978824,66.0058415 L15.5531216,66.0058415 C9.56553487,66.0058415 6.02409639,62.6834611 6.02409639,56.403797 L6.02409639,25.2245345 C6.02409639,18.9083607 9.56553487,15.62249 15.5531216,15.62249 L64.2935378,15.62249 C70.2811245,15.62249 73.8590727,18.9083607 73.8590727,25.2245345 L73.8590727,27.3420957 L51.5151515,27.3420957 C42.3877327,27.3420957 36.9843008,32.6359985 36.9843008,41.7269076 L36.9843008,62.354874 C36.9843008,64.1073384 37.1668492,65.6772545 37.5684556,67.1011318 L25.0091274,78.7477181 Z M78.5688207,82.6542534 L67.5428989,72.7601314 C66.0825119,71.4457831 65.2427893,71.007667 63.2347572,71.007667 L51.9897773,71.007667 C46.3307777,71.007667 42.9353779,67.9408543 42.9353779,61.9532676 L42.9718876,42.0554947 C42.9718876,36.067908 46.3307777,32.9645856 51.9897773,32.9645856 L84.9945235,32.9645856 C90.6900329,32.9645856 94.048923,36.067908 94.048923,42.0554947 L94.048923,61.9532676 C94.048923,67.9043447 90.6535232,71.007667 84.9945235,71.007667 L81.343556,71.007667 C79.77364,71.007667 78.5688207,71.9204089 78.5688207,73.928441 L78.5688207,82.6542534 Z"
          fill={props.fill && props.fill}
          fillRule="nonzero"
        ></path>
      </g>
    </svg>
  );
};

ClassroomSvg.defaultProps = {
  height: 20,
  width: 20,
};

ClassroomSvg.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default ClassroomSvg;
